import * as React from "react";
import { cn } from "./utils";
import { type LucideIcon } from "lucide-react";
import { FormBadge } from "./form-badge";

export interface FormBadgeGroupProps extends React.HTMLAttributes<HTMLDivElement> {
    icon?: LucideIcon;
    label: string;
    items: string[];
    variant?: "specialty" | "anatomic" | "indication" | "prevalence" | "status" | "scoring" | "study-type" | "country";
    iconClassName?: string;
}

const FormBadgeGroup = React.forwardRef<HTMLDivElement, FormBadgeGroupProps>(
    ({ className, icon: Icon, label, items, variant = "specialty", iconClassName, ...props }, ref) => {
        if (!items || items.length === 0) return null;

        return (
            <div ref={ref} className={cn("", className)} {...props}>
                <div className="flex items-center gap-2 mb-2">
                    {Icon && <Icon className={cn("w-4 h-4 text-slate-500", iconClassName)} />}
                    <span className="font-medium text-slate-600 text-sm">{label}:</span>
                </div>
                <div className="flex flex-wrap gap-1">
                    {items.map((item) => (
                        <FormBadge key={item} variant={variant}>
                            {item.replace(/_/g, " ")}
                        </FormBadge>
                    ))}
                </div>
            </div>
        );
    }
);

FormBadgeGroup.displayName = "FormBadgeGroup";

export { FormBadgeGroup };
